import { render, staticRenderFns } from "./BaseCardList.vue?vue&type=template&id=f8d45296&scoped=true&"
import script from "./BaseCardList.vue?vue&type=script&lang=js&"
export * from "./BaseCardList.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardList.vue?vue&type=style&index=0&id=f8d45296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d45296",
  null
  
)

export default component.exports